module.exports = __webpack_public_path__ + "img/free_class_banner.67492feb.png";